/*
 * @Author: Teemo Ding
 * @Date: 2021-06-23 10:48:04
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 10:46:27
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/StoreDetails/index.tsx
 */
import { getI18nFromGeneral } from '@/src/tools/tools';
import { Skeleton } from '@/src/components/Antd';
import RouteBlock from '@/src/constrains/RouterBlock/RouterBlock';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import {
  getCountry,
  getState,
  getStoreDetails,
  submitStoreDetails,
} from '@/src/request/settings/storeDetails';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';
import { Form, message } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { breadcrumbData } from './config';
import Organisation from './Organisation';
import StoreDetailsInfo from './StoreDetailsInfo';
import { get } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const permissions = () => {
  const view_store_details = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsStoreDetails,
        operation: EnumOperation.view_store_details,
      }),
    ],
  });
  const edit_setting = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsStoreDetails,
        operation: EnumOperation.edit_setting,
      }),
    ],
  });
  return {
    view_store_details,
    edit_setting,
  };
};

const StoreDetails = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { view_store_details, edit_setting } = permissions();
  const [form] = Form.useForm();
  const [hasModified, setHasModified] = useState(false);
  const [countries, setCountries] = useState<string[]>([]);
  const [store, setStore] = useState({ uuid: '' } as any);
  const [loading, setLoading] = useState(true);
  const [defaultAreaCode, setDefaultAreaCode] = useState('');
  //const [defaultAreaText, setDefaultAreaText] = useState('');
  const [states, setStates] = useState([]);
  const history = useHistory();

  useEffect(() => {
    if (view_store_details) {
      const lang = navigator.language; //获取浏览器默认语言。
      getCountry(lang).then((country) => {
        // console.log('country', country);
        setDefaultAreaCode(country.uuid);
        // setDefaultAreaText(
        //   country.areaCode ? `${country.name} +(${country.areaCode})` : '',
        // );
      });
      getStoreDetails().then((data) => {
        setCountries(data.countries);
        const store = data.store;
        setStore(store);

        setLoading(false);
        if (store.country.code) {
          handleCountryChange(store.country.code);
        }
      });
    } else {
      setLoading(false);
    }
  }, []);
  const handleCountryChange = (code) => {
    getState(code).then((state) => setStates(state));
  };

  const onFinish = (values) => {
    const { ...rest } = values;
    const body = {
      ...rest,
      uuid: store.uuid,
      timezone: store.timezone,
    };
    submitStoreDetails(body).then((data) => {
      message.success('Save success');
      setHasModified(false);
    });
  };
  const onValuesChange = (changedValues, allValues) => {
    if (Object.keys(changedValues)[0] == 'country') {
      handleCountryChange((Object.values(changedValues)[0] as any).code);
    }
    setHasModified(true);
  };
  const hasAreaCode = get(store, 'areaCodeInfo.uuid');
  const child = [
    {
      child: <StoreDetailsInfo disabled={!edit_setting} />,
    },
    {
      child: (
        <Organisation
          countries={countries}
          states={states}
          //defaultAreaText={defaultAreaText}
          disabled={!edit_setting}
        />
      ),
    },
  ];

  const goBackToList = () => {
    history.push({
      pathname: '/settings',
    });
  };

  const topLeft = (
    <TopLeft
      goBack={goBackToList}
      breadcrumbData={breadcrumbData({ getI18n })}
    />
  );

  const topRight = (
    <TopRight
      onDiscard={goBackToList}
      onSubmit={() => {
        form.submit();
      }}
      onSaveDisable={!hasModified}
    />
  );

  return (
    <Fragment>
      <RouteBlock
        onConfirm={(f) => f()}
        okText='Leave'
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.leave_header')}
        content={getI18nFromGeneral('general.commonHeader.leave_content')}
      />

      <Skeleton loading={loading} active>
        <Form
          initialValues={{
            ...store,
            areaCodeInfo: hasAreaCode
              ? get(store, 'areaCodeInfo')
              : { uuid: defaultAreaCode },

            mobileNumber: get(store, 'phone'),
          }}
          onValuesChange={onValuesChange}
          onFinish={onFinish}
          hideRequiredMark
          form={form}
          name='store_details'
          scrollToFirstError>
          <Layout
            elements={child}
            topLeft={topLeft}
            topRight={topRight}></Layout>
        </Form>
      </Skeleton>
    </Fragment>
  );
};
export default StoreDetails;
